import Utils from '@/common/utils/utils';
import FlagMessageCopy from '../tooltip/FlagMessageCopy';
import {
    isDisplayBtnCopyMsgId,
    isDisplayReactionBtn,
    isEditedMsg,
    onClickShowEditMsg,
    onOpenHistoryDialog
} from '../handler/MessageHandler';
import CopyIdElement from '@/component/common/CopyIdElement';
import I18n from '@/rI18n';
import { IconButton, Tooltip } from '@material-ui/core';
import { disableAutoScroll } from '../handler/FootprintHandler';

export const ChatBoxToolKnowledge = ({
    ticketInfo,
    item,
    setChatPostShowFlagMsgCopyMsgId,
    genMessageCopyShortLink,
    isDisplayBtnEdit,
    setOpenModalDeleteMsg,
    selectThread,
    isDisplayBtnDelete,
    setReactionPopoverId,
    setReactionPopover,
    reactionId,
    isEnableChat,
    editedMsgList,
    setIsOpenHistoryDialog,
    setIsLoadingHistoryList,
    setHistoryList,
    setMsgEditSelected,
    userChatList,
    setIsShowModalEditMsg,
    msgRefList,
    chatPostAllList,
    setChatPostUpdate,
    itemFile,
    chatPostShowFlagMsgCopyMsgId,
}) => {
    const chatBoxToolComponent = (
        <div className="chatBox-tools">
            <ul>
                {!Utils.isEmptyObject(itemFile) && Utils.isImageFile(itemFile?.fileInfo?.fileName) && Utils.isEmptyString(ticketInfo?.deletedAt) && (
                    <li className="msg-chat-copy-id-content">
                        <CopyIdElement
                            key={`copy-msg-${item.id}`}
                            copyId={itemFile?.id}
                            messageShareLink={Utils.getShareLinkImg({
                                attachFile: itemFile,
                                dataShareLink: ticketInfo.dataShareLink
                            })}
                            title={I18n.get('GET_URL')}
                            isShow={true}
                            setChatPostShowFlagMsgCopyMsgId={setChatPostShowFlagMsgCopyMsgId}
                            isCopyImgLink={true}
                        />
                    </li>
                )}
                {isDisplayBtnCopyMsgId(item, ticketInfo, selectThread) && (
                    <li className="msg-chat-copy-id-content">
                        <CopyIdElement
                            key={`copy-msg-${item.id}`}
                            copyId={!Utils.isEmptyObject(itemFile) ? itemFile?.id : item?.id}
                            messageShareLink={genMessageCopyShortLink(item)}
                            title={I18n.get('LABEL-CHATPOST-SHARELINK-TOOLTIP')}
                            isShow={true}
                            setChatPostShowFlagMsgCopyMsgId={setChatPostShowFlagMsgCopyMsgId}
                        />
                    </li>
                )}

                {isDisplayReactionBtn(ticketInfo, item, selectThread, isEnableChat) && (
                    <li>
                        <Tooltip title={I18n.get('COMBTN015')} placement="top" arrow>
                            <IconButton
                                aria-describedby={reactionId}
                                onClick={event => {
                                    disableAutoScroll(true);
                                    setReactionPopover(event.currentTarget);
                                    setReactionPopoverId(item.id);
                                }}
                            >
                                <img src="/assets/image/icon-reaction.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}

                {isEditedMsg(editedMsgList, item) && Utils.isEmptyString(ticketInfo?.deletedAt) && (
                    <li>
                        <Tooltip title={I18n.get('COMBTN016')} placement="top" arrow>
                            <IconButton
                                onClick={e =>
                                    onOpenHistoryDialog(
                                        null,
                                        item,
                                        setIsOpenHistoryDialog,
                                        setIsLoadingHistoryList,
                                        setHistoryList,
                                        setMsgEditSelected,
                                        userChatList
                                    )
                                }
                            >
                                <img src="/assets/image/icon-time.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}
                {isDisplayBtnEdit(item) && (
                    <li>
                        <Tooltip title={I18n.get('COMBTN012')} placement="top" arrow>
                            <IconButton
                                onClick={e =>
                                    onClickShowEditMsg(
                                        null,
                                        item,
                                        setMsgEditSelected,
                                        setIsShowModalEditMsg,
                                        msgRefList,
                                        chatPostAllList,
                                        setChatPostUpdate
                                    )
                                }
                            >
                                <img src="/assets/image/edit-icon.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}

                {isDisplayBtnDelete(item) && (
                    <li>
                        <Tooltip title={I18n.get('COMBTN013')} placement="top" arrow>
                            <IconButton
                                onClick={async () => {
                                    setOpenModalDeleteMsg({
                                        isOpen: true,
                                        msg: item
                                    });
                                }}
                            >
                                <img src="/assets/image/delete-icon.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}
            </ul>
        </div>
    );

    return !Utils.isEmptyObject(itemFile) ? (
        <FlagMessageCopy
            title={I18n.get('MSG-COPY-SHARELINK')}
            placement="top-end"
            open={!!chatPostShowFlagMsgCopyMsgId[itemFile?.id]}
        >
            {chatBoxToolComponent}
        </FlagMessageCopy>
    ) : (
        <>{chatBoxToolComponent}</>
    );
};
